import axios from "axios";
import { ENDPOINTS } from "../endpoints";

export const getMeetingWithTypes = async (programIds = []) => {
  try {
    const params = {};
    if (programIds && programIds.length > 0) {
      params.program_ids = programIds;
    }

    const response = await axios.get(ENDPOINTS.MEETING_WITH_TYPES.GET, { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const createMeetingWithType = async (data) => {
  try {
    const response = await axios.post(ENDPOINTS.MEETING_WITH_TYPES.CREATE, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateMeetingWithType = async (id, data) => {
  try {
    const response = await axios.put(`${ENDPOINTS.MEETING_WITH_TYPES.UPDATE}/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteMeetingWithType = async (id) => {
  try {
    const response = await axios.delete(`${ENDPOINTS.MEETING_WITH_TYPES.DELETE}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};
